<template>
  <LoginLayout>
    <RoutineLogoIcon :is-colored="true" class="logo" />
    <h1>Welcome</h1>
    <h2>
      Routine is the AI workspace for individuals and teams to work smarter.
    </h2>
    <BaseButton
      kind="important"
      type="secondary"
      text="Let's go →"
      @click="$emit('nextStep')"
    />
  </LoginLayout>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import LoginLayout from "@/components/login/LoginLayout.vue";
import { metrics } from "@/metrics";

import BaseButton from "../base/BaseButton.vue";
import RoutineLogoIcon from "../icons/RoutineLogoIcon.vue";

export default defineComponent({
  components: {
    BaseButton,
    LoginLayout,
    RoutineLogoIcon,
  },

  emits: {
    nextStep: () => true,
  },

  setup() {
    metrics.segment.page("Onboarding", { step: "welcome" });
  },
});
</script>

<style lang="scss" scoped>
h2 {
  max-width: 320px;
  margin-bottom: 32px;
}
</style>
